import { recentActivitiesQuery } from '@atlassian/search-client';
import { mapRecentActivitiesToSearchResult } from './recent-activities-mapper';
import { fg } from '@atlaskit/platform-feature-flags';

export const INCLUDED_PRODUCTS = ['confluence', 'jira', 'townsquare', 'graph'];

export const INCLUDED_OBJECT_TYPES = [
	'page',
	'blogpost',
	'whiteboard',
	'issue',
	'project',
	'goal',
	'content',
	'document',
	'remote-link',
];

export const fetchRecentActivities = async (cloudId: string, searchSessionId?: string) => {
	return await recentActivitiesQuery({
		variables: {
			filteredProducts: INCLUDED_PRODUCTS,
			filteredObjectTypes: fg('smartlinks-qf-recents')
				? INCLUDED_OBJECT_TYPES
				: INCLUDED_OBJECT_TYPES.filter((type) => type !== 'remote-link'),
			filteredRootContainerIds: [
				`ari:cloud:platform::site/${cloudId}`,
				`ari:cloud:townsquare::site/${cloudId}`,
			],
			itemsLimit: 200,
		},
	})
		.then((response) => {
			const edges = response.data?.activity?.myActivity?.all?.edges || [];
			try {
				return edges.map((edge) => mapRecentActivitiesToSearchResult(edge, searchSessionId || ''));
			} catch (error) {
				return [];
			}
		})
		.catch((error) => {
			throw error;
		});
};
